import { convertMbToByte } from "@/utils/file";

export const MAX_SIZE = convertMbToByte(10); // 10MB
export const MAX_JOB_DOCUMENT_FILE = 3;
export const MAX_JOB_UPLOAD_FILES = 5;

export const JOB_DOCUMENT_FILE_TYPES_EXTENSION = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".csv",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
  ".tif",
  ".tiff",
];

export const JOB_DOCUMENT_FILE_MINE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/csv",
  "text/plain",
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/tif",
  "image/tiff",
];

export const JOB_IMAGE_TYPES_EXTENSION = [".pdf", ".jpg", ".jpeg", ".png", ".gif", ".tif", ".tiff"];

export const JOB_IMAGE_MINE_TYPES = ["application/pdf", "image/jpg", "image/jpeg", "image/png", "image/gif", "image/tif", "image/tiff"];
